import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _toConsumableArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _styled from "@emotion/styled/base";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import ConfirmDialog from '@frontend/components/Dialogs/ConfirmDialog';
import { useWalletConfig } from '@frontend/providers/WalletConfigProvider';
import { useMemo, useState } from 'react';
import { AdjustMyFarmProfileDialog } from './AdjustMyFarmProfileDialog';
import TableDetailProfile from './TableDetailProfile';

var Container = _styled("div", true ? {
  target: "eaieveh0"
} : {
  target: "eaieveh0",
  label: "Container"
})(true ? {
  name: "1pjujy5",
  styles: "position:relative;margin-bottom:32px;box-sizing:border-box;overflow:hidden"
} : {
  name: "1pjujy5",
  styles: "position:relative;margin-bottom:32px;box-sizing:border-box;overflow:hidden",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var initialState = {
  open: false,
  walletAddress: '',
  walletID: 0,
  chain: 56
};

var WalletDetailProfileTable = function WalletDetailProfileTable(_ref) {
  var profile = _ref.profile;

  var _useWalletConfig = useWalletConfig(),
      dispatch = _useWalletConfig.dispatch;

  var _useState = useState(initialState),
      adjustWallet = _useState[0],
      setAdjustWallet = _useState[1];

  var _useState2 = useState(false),
      isShowPopupDelete = _useState2[0],
      setShowPopupDelete = _useState2[1];

  var _useState3 = useState(),
      deleteId = _useState3[0],
      setDeleteId = _useState3[1];

  var handleRemoveWallet = function handleRemoveWallet() {
    dispatch({
      type: 'REMOVE_WALLET',
      payload: {
        profileID: profile.profileID,
        walletID: deleteId
      }
    });
    setDeleteId(undefined);
    setShowPopupDelete(false);
  };

  var handleCancelRemove = function handleCancelRemove() {
    setDeleteId(undefined);
    setShowPopupDelete(false);
  };

  var handleSetRemoveWallet = function handleSetRemoveWallet(walletId) {
    setDeleteId(walletId);
    setShowPopupDelete(true);
  };

  var handleExcludePlatforms = function handleExcludePlatforms(_ref2) {
    var _profile$wallets$find;

    var platformName = _ref2.platformName,
        walletID = _ref2.walletID;
    var excludes = ((_profile$wallets$find = profile.wallets.find(function (wallet) {
      return wallet.walletID === walletID;
    })) === null || _profile$wallets$find === void 0 ? void 0 : _profile$wallets$find.excludes) || [];

    if (excludes.includes(platformName)) {
      //remove
      excludes = excludes.filter(function (name) {
        return name !== platformName;
      });
    } else {
      //add
      excludes = [].concat(_toConsumableArray(excludes), [platformName]);
    }

    dispatch({
      type: 'SET_EXCLUDES_PLATFORM',
      payload: {
        profileID: profile.profileID,
        walletID: walletID,
        excludes: excludes
      }
    });
  };

  var inspectExcludes = useMemo(function () {
    var _profile$wallets$find2;

    return ((_profile$wallets$find2 = profile.wallets.find(function (wallet) {
      return wallet.walletID === adjustWallet.walletID;
    })) === null || _profile$wallets$find2 === void 0 ? void 0 : _profile$wallets$find2.excludes) || [];
  }, [adjustWallet.walletID, profile.wallets]);
  return _jsxs(Container, {
    children: [_jsx(AdjustMyFarmProfileDialog, _objectSpread(_objectSpread({}, adjustWallet), {}, {
      excludes: inspectExcludes,
      onClose: function onClose() {
        return setAdjustWallet(initialState);
      },
      title: "Adjust My Farm",
      onToggleFarm: handleExcludePlatforms
    })), _jsx(ConfirmDialog, {
      title: _jsxs(_Fragment, {
        children: ["Are you sure you want to", _jsx("br", {}), "delete the whole wallet?"]
      }),
      textCancel: "No, I want to keep it",
      textConfirm: "Yes, I want to remove it.",
      open: isShowPopupDelete,
      onConfirm: handleRemoveWallet,
      onCancel: handleCancelRemove
    }), _jsx(TableDetailProfile, {
      data: profile.wallets,
      handleSetRemoveWallet: handleSetRemoveWallet,
      setAdjustWallet: setAdjustWallet
    })]
  });
};

export default WalletDetailProfileTable;